import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AssetRolloverService {

  constructor(
    private http: HttpClient,
    private jsonObjectFactory: JsonObjectFactoryService,
  ) {}

  getTaxYearDropDown(baseUrl: string, globalService: any): Observable<any> {
    const url = baseUrl + '/loadJsonObject';
    const params: any = { action_code: 'e83e1x' };

    if (globalService?.globalParams) {
      const gp = globalService.globalParams;
      if (gp.sso_id) params.sso_id = gp.sso_id;
      if (gp.jcd_key) params.jcd_key = gp.jcd_key;
      if (gp.scenario) params.scenario = gp.scenario;
      if (gp.screen_key) params.screen_key = gp.screen_key;
      if (gp.tax_year) params.tax_year = gp.tax_year;
    }

    return this.jsonObjectFactory.getJSONObj(url, params, globalService);
  }

  getScenarioDropDown(baseUrl: string, taxYear: string, globalService: any): Observable<any> {
    const url = baseUrl + '/loadJsonObject';
    const params: any = {
      action_code: 'va45va',
      p_tax_year: taxYear,
    };

    if (globalService?.globalParams) {
      const gp = globalService.globalParams;
      if (gp.sso_id) params.sso_id = gp.sso_id;
      if (gp.jcd_key) params.jcd_key = gp.jcd_key;
      if (gp.scenario) params.scenario = gp.scenario;
      if (gp.screen_key) params.screen_key = gp.screen_key;
    }

    return this.jsonObjectFactory.getJSONObj(url, params, globalService);
  }

  getParentMeDropdown(baseUrl: string, ssoId: string, taxYear: string, scenario: string, globalService: any): Observable<any> {
    const url = baseUrl + '/loadJsonObject';
    const params: any = {
      action_code: '07roqs',
      p_tax_year: taxYear,
    };

    if (ssoId) {
      params.sso_id = ssoId;
    } else if (globalService?.globalParams?.sso_id) {
      params.sso_id = globalService.globalParams.sso_id;
    }

    if (scenario) {
      params.p_scenario = String(scenario);
    } else if (globalService?.globalParams?.scenario) {
      params.p_scenario = String(globalService.globalParams.scenario);
    }

    if (globalService?.globalParams) {
      const gp = globalService.globalParams;
      if (gp.jcd_key) params.jcd_key = gp.jcd_key;
      if (gp.screen_key) params.screen_key = gp.screen_key;
    }

    return this.jsonObjectFactory.getJSONObj(url, params, globalService);
  }

  /**
   * Original AngularJS used $http.post() directly (JSON body), NOT JsonObjectFactory.saveJSON.
   * Action code: quo991
   * Merge order: GlobalService.globalParams first, then rolloverObj overrides.
   */
  executeAssetsRollover(
    baseUrl: string,
    ssoId: string,
    taxYear: string,
    scenario: string,
    parentMeKey: string,
    jcdKey: string,
    globalService: any,
  ): Observable<any> {
    const url = baseUrl + '/saveJsonObject?action_code=quo991';

    const params: any = {};
    if (globalService?.globalParams) {
      Object.assign(params, globalService.globalParams);
    }

    params.sso_id = ssoId || params.sso_id;
    params.p_tax_year = taxYear;
    params.p_scenario = scenario;
    params.p_me_key = parentMeKey;
    params.jcd_key = jcdKey || params.jcd_key;

    return this.http.post<any>(url, params, { withCredentials: true });
  }
}
